<ng-template #customCellTemplate let-day="day" let-locale="locale" let-trackByEventId="trackByEventId"
  let-validateDrag="validateDrag" let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay">
  <div class="cal-cell-top">
    <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
  </div>

  <div class="cal-events" *ngIf="day.events.length > 0">
    <div class="cal-event" *ngFor="let event of day.events; trackBy: trackByEventId"
      [ngStyle]="{ backgroundColor: event.color?.primary }" (mouseenter)="highlightDay.emit({ event: event })"
      (mouseleave)="unhighlightDay.emit({ event: event })" [mwlCalendarTooltip]="
        event.title | calendarEventTitle: 'monthTooltip':event
      " [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event" [tooltipTemplate]="tooltipTemplate"
      [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay" mwlDraggable
      [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active"
      [dropData]="{ event: event, draggedFrom: day }" [dragAxis]="{ x: event.draggable, y: event.draggable }"
      [validateDrag]="validateDrag" [touchStartLongPress]="{ delay: 300, delta: 30 }"
      (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
      [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'">
      <span>{{event.content}}</span>
    </div>

  </div>
</ng-template>

<div class="cal-month-view" role="grid">
  <mwl-calendar-month-view-header [days]="columnHeaders" [locale]="locale"
    (columnHeaderClicked)="columnHeaderClicked.emit($event)" [customTemplate]="headerTemplate">
  </mwl-calendar-month-view-header>
  <div class="cal-days">
    <div *ngFor="let rowIndex of view.rowOffsets; trackBy: trackByRowOffset">
      <div class="cal-cell-row">
        <div><span class="cal-day-number cal-KW-number"> KW {{ view.days[rowIndex].date | weekNumber }}</span></div>
        <mwl-calendar-month-cell *ngFor="
            let day of view.days
              | slice: rowIndex:rowIndex + view.totalDaysVisibleInWeek;
            trackBy: trackByDate
          " [ngClass]="day?.cssClass" [day]="day" [openDay]="openDay" [locale]="locale"
          [tooltipPlacement]="tooltipPlacement" [tooltipAppendToBody]="tooltipAppendToBody"
          [tooltipTemplate]="tooltipTemplate" [tooltipDelay]="tooltipDelay" [customTemplate]="customCellTemplate"
          [ngStyle]="{ backgroundColor: day.backgroundColor }"
          (mwlClick)="dayClicked.emit({ day: day, sourceEvent: $event })"
          [clickListenerDisabled]="dayClicked.observers.length === 0" (mwlKeydownEnter)="
            dayClicked.emit({ day: day, sourceEvent: $event })
          " (highlightDay)="toggleDayHighlight($event.event, true)"
          (unhighlightDay)="toggleDayHighlight($event.event, false)" mwlDroppable dragOverClass="cal-drag-over" (drop)="
            onDrop($event, day);
          " (dragover)="onDragover($event)" (eventClicked)="
            eventClicked.emit({
              event: $event.event,
              sourceEvent: $event.sourceEvent
            })
          " [attr.tabindex]="{} | calendarA11y: 'monthCellTabIndex'">

        </mwl-calendar-month-cell>
      </div>

      @if(openDay)
      {
      <mwl-calendar-open-day-events [locale]="locale" [isOpen]="openRowIndex === rowIndex" [events]=openDay.events
        [date]="viewDate" [customTemplate]="openDayEventsTemplate" [eventTitleTemplate]="eventTitleTemplate"
        [eventActionsTemplate]="eventActionsTemplate" (eventClicked)="
          eventClicked.emit({
            event: $event.event,
            sourceEvent: $event.sourceEvent
          })
        " mwlDroppable dragOverClass="cal-drag-over" (drop)="
          eventDropped(
            openDay,
            $event.dropData.event,
            $event.dropData.draggedFrom
          )
        ">

      </mwl-calendar-open-day-events>
      }
    </div>
  </div>
</div>

<div class="simple-month-view">
  <mwl-calendar-month-view
    [viewDate]="viewDate"
    [events]="[]">
  </mwl-calendar-month-view>
</div>


